<!-- Loading Section -->
<section class="page-loading" *ngIf="isLoading">
  <div class="loading-wrapper">
    
    <!-- Animation Lottie -->
    <ng-lottie
      [options]="loadingAnimation"
      width="220px"
      height="220px">
    </ng-lottie>

    <!-- Texte -->
    <h2 class="loading-title">Chargement en cours...</h2>
    <p class="loading-subtitle">
      Merci de patienter pendant que nous préparons votre contenu.
    </p>

    <!-- Barre de progression animée -->
    <div class="loading-bar">
      <div class="loading-bar__progress"></div>
    </div>

  </div>
</section>